import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateFormatService {

  constructor() { }

  private format:string = "DD/MM/YYYY";

  public setFormat(format:string) {
    this.format = format;
  }

  public getFormat(): string
  {
    return this.format;
  }

  public getLocale(): string
  {
    return "en-US";
  }  
}
